<input
  #input
  *ngIf="type !== 'checkbox'"
  class="input"
  [type]="type"
  [(value)]="value"
  [placeholder]="placeholder"
  [autocomplete]="autocomplete ? 'on' : 'off'"
  (input)="emit($event.target)"
  [max]="max"
  [min]="min"
  [step]="step"
  (focusin)="gotFocus()" />

<label *ngIf="type === 'checkbox'" class="container-checkbox">
  <input
    id="inputCheckbox"
    type="checkbox"
    [(checked)]="value"
    (input)="emitCheckbox($event.target)"
    [class]="errorStyle" />
  <span [class]="errorStyle + ' checkmark'"></span>
  <div class="content">
    <ng-content select="[content]"></ng-content>
    <div style="flex-grow: 1"></div>
    <div class="right-content">
      <ng-content select="[right-content]"></ng-content>
    </div>
  </div>
</label>
